import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction, createGetSuccessAction, StateCacheOptions } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { GameCollectionRaw } from "./game-collection.model";

const ACTION_PREFIX = "[Game Collection]";
export const GAME_COLLECTION_ACTION_TYPE = {
	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get All Success`,
	getAllFail: `${ACTION_PREFIX} Get All Fail`,
	getById: `${ACTION_PREFIX} Get By Id`,
	getByIdSuccess: `${ACTION_PREFIX} Get By Id Success`,
	getByIdFail: `${ACTION_PREFIX} Get By Id Fail`,
};

@Injectable({
	providedIn: "root",
})
export class GameCollectionAction {
	getAll(options?: Partial<StateCacheOptions>): Action {
		return createCachedGetAction(
			{
				type: GAME_COLLECTION_ACTION_TYPE.getAll,
			},
			options
		);
	}

	getAllSuccess(gameCollections: Record<string, GameCollectionRaw>): ActionWithPayload {
		return createGetSuccessAction({
			type: GAME_COLLECTION_ACTION_TYPE.getAllSuccess,
			payload: gameCollections,
		});
	}

	getAllFail(error: AppError): ActionWithPayload {
		return {
			type: GAME_COLLECTION_ACTION_TYPE.getAllFail,
			payload: error,
		};
	}

	getById(collectionId: string): Action {
		return createCachedGetAction({
			type: GAME_COLLECTION_ACTION_TYPE.getById,
			payload: collectionId,
		});
	}

	getByIdSuccess(gameCollection: Record<string, GameCollectionRaw>): ActionWithPayload {
		return createGetSuccessAction({
			type: GAME_COLLECTION_ACTION_TYPE.getByIdSuccess,
			payload: gameCollection,
		});
	}

	getByIdFail(error: AppError): ActionWithPayload {
		return {
			type: GAME_COLLECTION_ACTION_TYPE.getByIdFail,
			payload: error,
		};
	}
}
